// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import '../../../css/rules.css'
import AppLogoImg from "../../../components/Utils/AppLogoImg.js"

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")

const RulesElementSelectorList = (params) => {    

    useEffect(() => {          
      console.log("Componente selector elementos reglas cargado correctamente.")       
      marcarElementoActualSeleccionado() 

      var literalTitulo = ""

      if(params.objRuleElementSelector.selectId.includes("Atributos")){
        literalTitulo = "Datos de "+initialConfigCommonJS.obtenerLiteralAtributo(params.objRuleElementSelector.categoria)        
      }
      else{
        literalTitulo = "Acciones de "+initialConfigCommonJS.obtenerLiteralAtributo(params.objRuleElementSelector.categoria)
      }
      
      literalTitulo = literalTitulo.charAt(0).toUpperCase() + literalTitulo.slice(1).toLowerCase();

      document.getElementById("tituloListadoDatosAccionesReglas").innerHTML = literalTitulo

    },[params.objRuleElementSelector]);

    function seleccionarElemento(valorElementoSeleccionado){
      document.getElementById(params.objRuleElementSelector.selectId).value = valorElementoSeleccionado
      
      var element = document.getElementById(params.objRuleElementSelector.selectId);
      var event = new Event('change', { bubbles: true });
      element.dispatchEvent(event);

      params.visibilidadModalFiltradoDatos("cerrar")
    }

    function marcarElementoActualSeleccionado(){

      try{
        var listadoElementosSeleccionables = document.getElementById("listadoElementosSeleccionReglas").querySelectorAll("input[type='checkbox']")   

        var idElementoTemp = ""    
      
        for (var i = 0; i < listadoElementosSeleccionables.length; i++) {
          
          idElementoTemp = listadoElementosSeleccionables[i].id
          
          if( document.getElementById(idElementoTemp).id === document.getElementById(params.objRuleElementSelector.selectId).value ){
            document.getElementById(idElementoTemp).checked = true            
          }
          else{
            document.getElementById(idElementoTemp).checked = false            
          }
      
        }
      }
      catch(error){console.log(error)}

    }

    const listRulesSelectionElements = params.objRuleElementSelector.valores.map((SelectionElement, index) =>
      <React.Fragment key={"RSE"+index}>
        <input type="checkbox" id={SelectionElement.valor} searchtext={SelectionElement.texto} onClick={() => seleccionarElemento(SelectionElement.valor)}/>                
        <label id={"labelDatos"+SelectionElement.valor} className="icon-wrapper" htmlFor={SelectionElement.valor} >            
          { params.objRuleElementSelector.categoria === "Devices" || params.objRuleElementSelector.categoria ==="Dispositivos" ?
            <figure className="avatar size-m">            
              <AppLogoImg aplicacion={SelectionElement.valor.split("|")[0].replaceAll("post","").replaceAll("Command","").toUpperCase()}/>
            </figure>
            :
            <></>
          }
          <span className="label" >{SelectionElement.texto}</span>
        </label>
      </React.Fragment>
    );    

    return (      
      <fieldset id="listadoElementosSeleccionReglas" className="check multiple gap-02 accordion-content">
        {listRulesSelectionElements}
      </fieldset>
    )

}

export default RulesElementSelectorList